// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2X-pH","range":"MonthRangeSwitch_range__1Znqa","disabled":"MonthRangeSwitch_disabled__Gc6Th"};